import axios from "axios"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import Button from "@material-ui/core/Button"

import { DialogTitle } from "components/partials"
import { Alert } from "components/widgets"
import { AxiosHelper } from "common/helpers"

const PasswordResetDialog = props => {
  const { isLoading, onConfirm: onConfirmProp, ...rest } = props
  const { t } = useTranslation()
  const [error, setError] = useState(null)

  function onClose() {
    if (rest.onClose) {
      rest.onClose({}, "backdropClick")
    }
  }

  async function onConfirm() {
    let hasError = false

    try {
      await onConfirmProp()
    } catch (error) {
      hasError = true

      if (axios.isAxiosError(error)) {
        if (error.response?.status === 403) {
          setError(t("errors.insufficientPermission"))
        } else {
          const parsed = AxiosHelper.parseError(error)
          if (typeof parsed === "string") {
            setError(parsed)
          } else {
            setError(t("errors.somethingWentWrong"))
          }
        }
      }
    }

    if (!hasError) {
      onClose()
    }
  }

  function onExited() {
    setError(null)
  }

  return (
    <Dialog
      {...rest}
      TransitionProps={{
        onExited
      }}
    >
      <DialogTitle onClose={onClose}>
        {t("view.adminUsers.resetPasswordModalTitle")}
      </DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" marginBottom={2}>
            {error}
          </Alert>
        )}

        <DialogContentText>
          {t("view.adminUsers.resetPasswordModalBody1")}
        </DialogContentText>
        <DialogContentText>
          {t("view.adminUsers.resetPasswordModalBody2")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t("view.adminUsers.cancel")}</Button>
        <Button onClick={onConfirm} disabled={isLoading}>
          {isLoading
            ? t("view.adminUsers.sendResetPasswordLoading")
            : t("view.adminUsers.sendResetPassword")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PasswordResetDialog
